const convertToOrderDeeplink = (
  countryCode: string,
  storeId: string | null,
  code: string | null,
  checkoutId: string | null,
) => {
  const prefix = `abnk://${countryCode}/order`;

  if (storeId) return `${prefix}?store_id=${storeId}`;
  if (code) return `${prefix}?order_campaign_referred_code=${code}`;
  if (checkoutId) return `${prefix}?checkout_id=${checkoutId}`;

  return null;
};

export default convertToOrderDeeplink;
